"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HtmlChiaSeed = void 0;
var React = require("react");
var HtmlChiaSeed = function (props) {
    var size = 14;
    return (React.createElement(React.Fragment, null,
        props.colorIndicatorsEnabled && (React.createElement("div", { style: __assign(__assign({ position: 'relative', transform: "translateX(" + props.x + "px) translateY(" + props.y + "px)" }, makeDotStyle(size * props.haloRatio)), { backgroundColor: props.color, opacity: 0.3 }) })),
        React.createElement("div", { style: __assign(__assign({ position: 'relative', transform: "translateX(" + props.x + "px) translateY(" + props.y + "px)" }, makeDotStyle(size)), { backgroundColor: props.color }) })));
};
exports.HtmlChiaSeed = HtmlChiaSeed;
var makeDotStyle = function (size) { return ({
    position: 'absolute',
    left: -size / 2,
    top: -size / 2,
    height: size,
    width: size,
    borderRadius: size,
    border: '1px',
    borderColor: 'white',
    borderStyle: 'solid',
    pointerEvents: 'none',
    boxSizing: 'border-box',
}); };
//# sourceMappingURL=HtmlChiaSeed.js.map